import { FunctionComponent } from 'react';

import { ProductImage } from '@savgroup-front-common/core/atoms/ProductImage';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';

import messages from '../../messages';
import { ProductsInfoMinimal } from '../../ProductsInfo.types';

import {
  $CardContentDescription,
  $CardContentProductName,
  $CardContentQuantity,
  $CardContentSmallThumbnail,
  $CardContentSmallThumbnailWrapper,
  $CardContentThumbnail,
  $CardContentThumbnailWrapper,
} from './MultiProductInfoDescription.styles';

const MultiProductInfoDescription: FunctionComponent<{
  productsInfo?: ProductsInfoMinimal[];
}> = ({ productsInfo }) => {
  const hasPicture = productsInfo?.some(
    (productInfo) => productInfo.modelPictureUrl,
  );
  const pictures = hasPicture
    ? productsInfo
        ?.map((productInfo) => productInfo.modelPictureUrl)
        .slice(0, 4)
    : [];

  const sameProduct = !productsInfo?.some(
    (productInfo) => productsInfo[0].modelName !== productInfo.modelName,
  );

  return (
    <>
      {!sameProduct && (
        <>
          {hasPicture &&
            pictures?.map((picture, index) => (
              <$CardContentSmallThumbnailWrapper key={picture}>
                <$CardContentSmallThumbnail>
                  <ProductImage
                    pictureUrl={picture}
                    dataTestId={`productImage_${index}`}
                  />
                </$CardContentSmallThumbnail>
              </$CardContentSmallThumbnailWrapper>
            ))}

          <$CardContentDescription>
            <$CardContentProductName data-testid="productsQuantity">
              <SafeFormattedMessageWithoutSpread
                message={messages.multiproductLength}
                values={{ itemsLength: productsInfo?.length }}
              />
            </$CardContentProductName>
          </$CardContentDescription>
        </>
      )}
      {sameProduct && productsInfo && (
        <>
          {((!productsInfo[0]?.modelPictureUrl &&
            productsInfo[0]?.modelTypeId) ||
            productsInfo[0]?.modelPictureUrl) && (
            <$CardContentThumbnailWrapper>
              <$CardContentThumbnail>
                <ProductImage
                  pictureUrl={productsInfo[0]?.modelPictureUrl}
                  dataTestId="productImage"
                />
              </$CardContentThumbnail>
            </$CardContentThumbnailWrapper>
          )}
          <$CardContentDescription>
            <$CardContentProductName data-testid="productDisplayName">
              {productsInfo[0]?.displayName}
            </$CardContentProductName>

            <$CardContentQuantity data-testid="productQuantity">
              <SafeFormattedMessageWithoutSpread
                message={messages.quantity}
                values={{
                  quantity: productsInfo?.length,
                }}
              />
            </$CardContentQuantity>
          </$CardContentDescription>
        </>
      )}
    </>
  );
};

MultiProductInfoDescription.displayName = 'MultiProductInfoDescription';
export default MultiProductInfoDescription;
